export default "__VITE_ASSET__BeFFqDBF__"